import { c as _c } from "react/compiler-runtime";
import styles from "./ReasonForVisit.module.css";
export const CheckUp = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={`${styles.reasonForVisitIcon} ${styles.reasonForVisitIconOtherCheckup}`}><img src="/assets/aspenscheduler/svgs/other-checkup.svg" alt="" width={22} height={20} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};